// extracted by mini-css-extract-plugin
export default {"Block":"DynamicContent_Block__BaRO5","Separator":"DynamicContent_Separator__qF6dY"};